import { noop } from 'lodash'
import { useTranslation } from 'react-i18next'
import { Text, Box, Heading } from '@machobear/design-system'
import { colors } from '@/styles'
import { EquifaxLogo, InfoTransparent } from '@/components/icons'

type PageTitleProps = {
  title: string
  showInfo?: boolean
  handleClick?: () => void
  showPoweredBy?: boolean
  noMobileMarginTop?: boolean
  clickId?: string
}

const PageTitle: React.FC<PageTitleProps> = ({
  title = '',
  showInfo = false,
  handleClick = noop,
  showPoweredBy = false,
  noMobileMarginTop = false,
  clickId = ''
}) => {
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      justifyContent="spaceBetween"
      alignItems="center"
      marginTop="large"
      marginBottom={{ mobile: 'medium', desktop: 'large' }}
    >
      <Box display="flex" gap="xsmall" alignItems="center">
        <Heading level="4">{title}</Heading>
        {showInfo && <InfoTransparent id={clickId} onClick={handleClick} fill={colors.grey40} />}
      </Box>
      {showPoweredBy && (
        <Box display="flex" gap="xsmall" alignItems="center">
          <Text tone="tertiary" size="small">
            {t('b.trust_score.in_partnership_with', 'In partnership with:')}
          </Text>
          <EquifaxLogo width={67} />
        </Box>
      )}
    </Box>
  )
}

export default PageTitle
